import { ConfirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import Helpers from "../../../utils/helpers";
import CommonPanel from "../../common/common-panel";
import LoadingScreen from "../../common/Loading";
import CameraOperatorsTable from "./components/table";
import CameraOperatorsService from "../../../services/AuraCamera/camera-operators/camer-operators.service";
import { useNavigate } from "react-router-dom";
const CameraOperator = () => {
  const session = window.localStorage;
  var navigate = useNavigate();
  const [isLoading, isLoadingUpdate] = useState(false);
  const toast = useRef<any>(null);
  const [isGrid, layoutToggle] = useState(false);
  const [activeClass, setActiveClass] = useState<any>({
    gridActive: "",
    tableActive: "icon-active",
  });
  const [CameraOperatorsTableValues, setCameraOperatorsTableValues] =
    useState<any>([]);
  useEffect(() => {
    CameraOperatorsService.GetCameraOperatorsData().then((res) => {
      setCameraOperatorsTableValues(res);
    });


  }, []);


  const showToast = (
    severityValue: any,
    summaryValue: any,
    detailValue: any
  ) => {
    toast?.current?.clear();
    toast?.current?.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  useEffect(() => {
    if (session.getItem("setCameraOperatorUpdateToastFlag") == "true") {
      session.setItem("setCameraOperatorUpdateToastFlag", "false");

      showToast("success", "Camera opertor updated", "Camera opertor updated successfully.");
    }

    if (session.getItem("setCameraOperatorCreateToastFlag") == "true") {
      session.setItem("setCameraOperatorCreateToastFlag", "false");

      showToast("success", "Camera operator created", "Camera operator successfully.");
    }


  }, []);

  const handleLayout = (childvalue: any) => {
    layoutToggle(childvalue);
    if (childvalue === true) {
      setActiveClass({
        gridActive: "icon-active",
        tableActive: "",
      });
    } else {
      setActiveClass({
        gridActive: "",
        tableActive: "icon-active",
      });
    }
  };
  const handleDownload = () => {
    let SitesTableValuesDeepCopy = JSON.parse(
      JSON.stringify(CameraOperatorsTableValues)
    );
    if (SitesTableValuesDeepCopy?.length > 0) {

      SitesTableValuesDeepCopy?.map((val: any, i: any) => {
        if (val.lastTrainingDate != null) {
          val.finalLastDate = Helpers.convertUTCtoMMDDYYYY(val.lastTrainingDate);
        } else {
          val.finalLastDate = "";
        }

        if (val.initialTrainingDate != null) {
          val.finalIniDate = Helpers.convertUTCtoMMDDYYYY(val.initialTrainingDate);
        } else {
          val.finalIniDate = "";
        }
      });


      Helpers.exportToCSV(
        SitesTableValuesDeepCopy,
        "Camera_operators",
        "Camera_operators",
        {
          company: "Company",
          name: "Name",
          email: "Email",
          contact_number: "Contact number",
          // ogi_initial_training: "OGI Initial training",
          finalIniDate: "Initial training date",
          finalLastDate: "Last Training Date",
          ogI_Refreshing_Time: "Refresher training",
          total_Training_Hours: "Total operating hours",
        },
        [
          "company",

          "name",
          "email",
          "contact_number",
          // "ogi_initial_training",
          "finalIniDate",
          "finalLastDate",
          "ogI_Refreshing_Time",
          "total_Training_Hours",
        ]
      );
    }
  };

  const [FilterSizeSelectedVal, setFilterSizeSelectedVal] = useState<any>([]);

  return (
    <>
      <LoadingScreen isLoading={isLoading} />
      <Toast ref={toast} style={{ marginTop: "25px", zIndex: 9999 }} />
      <ConfirmDialog />
      <nav aria-label="breadcrumb" className="breadcrumb--wrapper">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a
              onClick={(e) => {
                navigate(`/aura-camera/operations`);
              }}
            >
              Dashboard
            </a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            <a>Camera operators</a>
          </li>
        </ol>
      </nav>
      <div className="content__header">
        <div className="content__wrap">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <h4 className="page-heading"></h4>
            </div>
          </div>
        </div>
      </div>

      <div className="content__boxed dashboard_aogi_content_box_first">
        <div className="content__wrap">
          <div className="dashboard_main_div">
            <div className="card all-surveys-table card-mt">
              <CommonPanel
                tableData={handleLayout}
                gridData={handleLayout}
                activeClass={activeClass}
                downloadData={handleDownload}
                InnerComponent={
                  <CameraOperatorsTable
                    isGrid={isGrid}
                    filteredValues={CameraOperatorsTableValues}
                    filterBySize={FilterSizeSelectedVal}
                  />
                }
                Heading={`Camera operators`}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CameraOperator;
